<template>
    <x-quick-action-button title="Ubah"
        :url="url"
        icon="pencil"
        :disabled="disabled"
        color="primary"/>
</template>

<script>
import XQuickActionButton from './XQuickActionButton.vue'
export default {
    components: { XQuickActionButton },
    props: {
        disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
        url: {
            type: String,
            required: true,
        },
    },
}
</script>